module.exports = __webpack_public_path__ + "static/media/icon_trophy.d3919b1f.png";